// Fallback value
export default [
    'operations-pcB9CXVn',
    'personaliz-4ZcwmKUq',
    'recommenda-YVrqA7mP',
];
